import { Observable, finalize } from 'rxjs';

import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { LoaderState } from '@cxc/core/services';

export function httpLoaderInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const loaderState = inject(LoaderState);

  if (!req.headers.has('Loader-Opt-In')) {
    return next(req);
  }

  if (req.headers.get('Loader-Opt-In') === 'false') {
    req = req.clone({
      headers: req.headers.delete('Loader-Opt-In'),
    });
    return next(req);
  }

  const key = req.headers.get('Loader-Opt-In')!;

  req = req.clone({
    headers: req.headers.delete('Loader-Opt-In'),
  });

  // Inform that the loader should be visible
  loaderState.loadingMap.update(loadingMap => {
    loadingMap.set(key, true);
    return loadingMap;
  });
  // Increment queue
  loaderState.queueMapIncrement(key);

  return next(req).pipe(
    finalize(() => {
      setTimeout(() => {
        loaderState.queueMapDecrement(key);

        if (loaderState.queueMap().get(key) === 0) {
          // Dismiss loader
          loaderState.loadingMap.update(loadingMap => {
            loadingMap.set(key, false);
            return loadingMap;
          });
        }
      }, loaderState.duration());
    })
  );
}
